import React, { useEffect } from "react";
import { LEGAL_PAGES } from "../data/legalPages";

const SITE_URL = "https://pawground.app";
const EMAIL = "info@pawground.app";

const setHead = (sel, attr, value) => {
  let el = document.querySelector(sel);
  if (!el) {
    const [, tag, key, name] = sel.match(/^(\w+)\[(\w+)="([^"]+)"\]$/);
    el = document.createElement(tag);
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

// Turns the contact email inside copy into a mailto link.
const withEmail = (text) =>
  text.split(EMAIL).flatMap((part, i) =>
    i === 0 ? [part] : [<a key={i} href={`mailto:${EMAIL}`} className="text-brand-forest font-semibold underline underline-offset-2">{EMAIL}</a>, part]
  );

const Block = ({ block, idx }) => {
  if (block.h2) {
    return <h2 className="font-heading text-xl sm:text-2xl font-bold text-brand-ink mt-10 mb-3" data-testid={`legal-h2-${idx}`}>{block.h2}</h2>;
  }
  if (block.ul) {
    return (
      <ul className="list-disc pl-6 space-y-2 text-brand-ink/80 leading-relaxed">
        {block.ul.map((item) => <li key={item}>{withEmail(item)}</li>)}
      </ul>
    );
  }
  return <p className="text-brand-ink/80 leading-relaxed mt-3">{withEmail(block.p)}</p>;
};

export default function LegalPage({ pageKey }) {
  const page = LEGAL_PAGES[pageKey];
  const canonical = `${SITE_URL}${page.path}`;

  useEffect(() => {
    document.title = page.metaTitle;
    setHead('meta[name="description"]', "content", page.metaDescription);
    setHead('meta[name="robots"]', "content", "index, follow");
    setHead('link[rel="canonical"]', "href", canonical);
    setHead('meta[property="og:title"]', "content", page.metaTitle);
    setHead('meta[property="og:description"]', "content", page.metaDescription);
    setHead('meta[property="og:url"]', "content", canonical);
    setHead('meta[property="og:type"]', "content", "website");
    window.scrollTo(0, 0);
  }, [page, canonical]);

  return (
    <div className="min-h-screen bg-brand-cream" data-testid={`legal-page-${pageKey}`}>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 pt-10 pb-20 text-sm sm:text-base">
        <h1 className="font-heading text-4xl sm:text-5xl font-black text-brand-ink leading-tight" data-testid="legal-title">
          {page.heading}
        </h1>
        <p className="text-sm text-brand-ink/60 mt-3" data-testid="legal-effective-date">{page.effective}</p>
        {page.blocks.map((b, i) => <Block key={i} block={b} idx={i} />)}
      </article>
    </div>
  );
}
